import Enum from './Enum';

export const TourStatusEnum = new Enum({
    InProgress: 'IN_PROGRESS',
    Queued: 'QUEUED',
    Completed: 'COMPLETED'
});
